import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Amenities from '../components/Amenities'
import Readmore from '../components/Readmore'
import PlaceMetaData from '../components/PlaceMetaData'
import InfoPanelContent from '../components/InfoPanelContent'
import InfoPanelSummary from '../components/InfoPanelSummary'
import InfoPanelActions from '../components/InfoPanelActions'

import { 
  useReservationActions,
  useStepStats, 
  useStepActions } from '../hooks'

import { 
  useStep, 
  useStepAmenities, 
  addDefaultArgs } from '../api'

import { setPermentMapPin } from '../slices/map'

const StepSummary = (props) => {
  const { step, trail_id, route_id, current_trail_id } = props
  const { distance_from_trail, length, time,  trail_id:near_trail_id} = useStepStats({ step: step, 
    trail_id: trail_id, route_id: route_id, current_trail_id: current_trail_id }) || {}
  const { elevation, amenities } = step || {}
  const icons = amenities && Object.keys(amenities)
  const trail = `stage ${current_trail_id || trail_id}`
  return <InfoPanelSummary icons={icons} 
                           distance_from_trail={distance_from_trail} 
                           length={length} 
                           time={time} 
                           trail_id={near_trail_id}
                           route_id={route_id}
                           elevation={elevation} />
}

const StepActions = (props) => {
  const { step, trail_id, route_id, current_trail_id } = props
  const actions = useStepActions({ route_id: route_id, current_trail_id: current_trail_id, 
    step: step, trail_id: trail_id})
  const reservation = (step.is_start_stop && step.step_id > 1) ? {
    type: 'trail',
    trail_id: trail_id,
  } : {
    type: 'step',
    trail_id: trail_id,
    step_id: step.step_id
  }
  const reservationActions = useReservationActions([
    route_id, 
    current_trail_id, 
    reservation
  ], {skip: !step?.is_bookable || step?.amenities['accommodation'] <= 1})

  if (!reservationActions && !actions) return null
  return <InfoPanelActions actions={reservationActions.concat(actions)} />
}



const StepInfo = (props) => {
  const { step_trail_id, step_id, route_id, trail_id } = props
  const dispach = useDispatch()
  const step = useStep({ routeId: route_id, trailId: step_trail_id, stepId: step_id })
  const { uuid, title, subtitle, amenities, description, images, lnglat } = step || {}
  const summary = <StepSummary step={step} trail_id={step_trail_id} route_id={route_id} current_trail_id={trail_id}/>
  const actions = step && <StepActions step={step} trail_id={step_trail_id} route_id={route_id} current_trail_id={trail_id}/>
  const useAmenities = addDefaultArgs(useStepAmenities, { routeId: route_id, trailId: step_trail_id, stepId: step_id })

  useEffect(() => {
    if (lnglat) {
      dispach(setPermentMapPin(lnglat))
    }
    return () => {
      dispach(setPermentMapPin(null))
    }
  }, [lnglat, dispach])

  return (
    <InfoPanelContent key={`step-${trail_id}-${step_id}`}
                      title={title}
                      subtitle={subtitle}
                      images={images}
                      summary={summary}>

      <PlaceMetaData place={step} shareImageTitle={title} />

      { description && (
        <Readmore maxHeight={200}>
          <div className="pwa__infopanel__descriptions fade-in delay"
            dangerouslySetInnerHTML={{ __html: description }}>
          </div>
        </Readmore>
      )}

      { amenities && (
        <Amenities useAmenities={useAmenities} amenities={amenities}/>
      )}

      { actions }

    </InfoPanelContent>
  )
}

export default StepInfo
